import { render } from "./bannerPage.vue?vue&type=template&id=161cbbb3&scoped=true"
import script from "./bannerPage.vue?vue&type=script&lang=js"
export * from "./bannerPage.vue?vue&type=script&lang=js"

import "./bannerPage.vue?vue&type=style&index=0&id=161cbbb3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-161cbbb3"]])

export default __exports__